<template>
  <step-section
    :title="$t('innovationsStepTitle')"
    :short-description="$t('innovationsStepDescription')"
    :loading="loading$"
    :step-number="getStepNumber('innovations')"
  >
    <div class="row row--custom">
      <div
        class="col-12 col-xs-6 col-md-6--custom col-item-3 col-margin"
        v-for="innovation in innovations"
        :key="innovation.id"
      >
        <innovation-block
          :id="innovation.id"
          :name="innovation.name"
          :photo="innovation.photo"
          :icon="innovation.icon"
          :description="innovation.description"
          :attributes="innovation.attributes"
          :checked="isInnovationChecked(innovation)"
          @click="handleItemClick(innovation)"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import InnovationBlock from '@/components/blocks/InnovationBlock.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'InnovationsStep',
    mixins: [stepMixin],
    props: {
      innovations: Array,
    },
    methods: {
      isInnovationChecked(innovation) {
        const { form: { innovations = [] } } = this;
        return innovations.findIndex(x => x.id === innovation.id) !== -1;
      },
      handleItemClick(innovation) {
        const { form, updateFormField } = this;
        const innovations = [...form.innovations];
        const index = innovations.findIndex(x => x.id === innovation.id);

        if (index === -1) {
          innovations.push({
            id: innovation.id,
            name: innovation.name,
            icon: innovation.icon,
          });
        } else {
          innovations.splice(index, 1);
        }

        updateFormField({
          field: 'innovations',
          value: innovations,
        });
      },
    },
    components: {
      InnovationBlock,
    },
  };
</script>
